interface TrustBarProps {
  tagline?: string;
}

const trustItems = [
  { icon: 'ri-time-line', text: 'Flexible Booking' },
  { icon: 'ri-tools-line', text: 'Professional Equipment' },
  { icon: 'ri-map-pin-2-line', text: 'Prime Locations' },
  { icon: 'ri-star-fill', text: '4.9 Google Rating' },
  { icon: 'ri-shield-check-line', text: 'Fully Insured' },
  { icon: 'ri-calendar-check-line', text: 'Instant Confirmation' },
];

export default function TrustBar({ tagline = 'Trusted by Creators, Agencies & Production Teams' }: TrustBarProps) {
  return (
    <section className="bg-stone-50 border-y border-stone-200">
      <div className="max-w-7xl mx-auto px-6 py-7">
        <div className="flex flex-col md:flex-row items-center gap-6 md:gap-0 md:justify-between">
          <p className="text-stone-500 text-xs font-semibold uppercase tracking-widest md:mr-8 whitespace-nowrap flex-shrink-0">
            {tagline}
          </p>
          <div className="hidden md:block w-px h-10 bg-stone-200 flex-shrink-0" />
          <div className="flex flex-wrap items-center justify-center md:justify-end gap-x-7 gap-y-3 flex-1">
            {trustItems.map((item) => (
              <div key={item.text} className="flex items-center gap-2">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i className={`${item.icon} text-amber-500 text-base`} />
                </div>
                <span className="text-stone-600 text-sm font-medium whitespace-nowrap">{item.text}</span>
              </div>
            ))}
          </div>
          <div className="hidden lg:flex items-center gap-2 ml-8 flex-shrink-0">
            <div className="flex">
              {[1, 2, 3, 4, 5].map((s) => (
                <i key={s} className="ri-star-fill text-amber-400 text-sm" />
              ))}
            </div>
            <span className="text-stone-700 text-sm font-semibold">4.9</span>
            <span className="text-stone-400 text-xs">(840+ reviews)</span>
          </div>
        </div>
      </div>
    </section>
  );
}
